import type { Session } from './session.ts';

/** The `/account` sections a forced redirect can open (frontend.md §2 "/account"). */
export type ForcedAccountSection = 'wachtwoord' | 'beveiliging';

/**
 * What the account must do before anything else (security-privacy.md §1): choose a new password
 * (`mustChangePassword`: the server answers 403 `auth.password_change_required` everywhere else)
 * or set up MFA when the role requires it (403 `auth.mfa_enrollment_required`). `undefined` when
 * the account is complete.
 */
export function forcedAccountSection(session: Session): ForcedAccountSection | undefined {
  if (session.mustChangePassword) return 'wachtwoord';
  if (session.mfa.required && !session.mfa.enabled) return 'beveiliging';
  return undefined;
}
